import React from 'react';
import '../auth.css';
import i18n from '../i18n';
import {connect} from 'react-redux'
import axios from 'axios';
import { SemanticToastContainer, toast } from 'react-semantic-toasts';
import 'react-semantic-toasts/styles/react-semantic-alert.css';
import {reactLocalStorage} from 'reactjs-localstorage';
import { API_BASE_URL } from "../utils/endpoints";

class FormForgetDesign extends React.Component
 {
   constructor(props)
    {
       super(props);
       this.state = { user_name: '' };

       this.state={code :''};

       this.state = { password: '' };

       this.state={re_password :''};
       this.state={isArabic :true};
   }

    resetSendCode=(e)=> {
      e.preventDefault();
      var ip=API_BASE_URL;
var s2 = "localhost:3000";
var apiBaseUrl;
if(ip.includes(s2))
{
  apiBaseUrl = API_BASE_URL + "/core/user/rest/auth/forgetpassword";
}
else
{
 apiBaseUrl = ip+"/core/user/rest/auth/forgetpassword";
}
var data={};
var headers = {
       'content-type': 'application/json',
       'username': this.state.user_name,

   }
axios.post(apiBaseUrl,data,{headers: headers}).then(function (response)
{

  if(response.status === 200)
  {
     if(response.data.status === 'success')
     {
       if(response.data.result.message ==="send successfully")
       {
        toast({
          type: 'success',
          title: i18n.t('success.label'),
          description: response.data.result.message,
          animation: 'bounce',
          time: 5000,

      });
         document.querySelector('.reset_send_code').style = 'display:none';
         document.querySelector('.reset_check_code').style = 'display:block';

       }

     }


  }
  else if(response.status === 204){
  console.log("Something wrong");

  }
  else{
  console.log("Something wrong");

  }
  })
  .catch(function (error) {
  console.log(error);
  });




    }
    componentDidMount() {
      if( reactLocalStorage.get('lang') ==='ar')
    {
      i18n.changeLanguage('ar');
      this.setState({isArabic :false})
    }
    else{
      i18n.changeLanguage('en');
      this.setState({isArabic :true})
    }


    }
    resetCheckCode=(e) =>{
      e.preventDefault();
      var ip=API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if(ip.includes(s2))
      {
        apiBaseUrl = API_BASE_URL + "/core/user/rest/auth/confirmforgetpassword";
      }
      else
      {
       apiBaseUrl = ip+"/core/user/rest/auth/confirmforgetpassword";
      }
      var data={};
      var headers = {
             'content-type': 'application/json',
             'username': this.state.user_name,
             'code':this.state.code,
             'new_password':this.state.password

         }
      axios.post(apiBaseUrl,data,{headers: headers}).then(function (response)
      {

        if(response.status === 200)
        {
           if(response.data.status === 'success')
           {
             if(response.data.result.message)
             {
              toast({
                type: 'success',
                title: i18n.t('success.label'),
                description: response.data.result.message,
                animation: 'bounce',
                time: 5000,

            });
            window.location="/app"

             }

    }
    if(response.data.status === "failed")
    {
      toast({
        type: "failed",
        title: i18n.t("failed.label"),
        description: response.data.result.errorReposne,
        animation: "bounce",
        time: 5000
      });
      if(response.data.result.errorReposne == 'Password does not meet complexity requirements or contains username')
      {
        document.querySelector(".modalIsOpenError").style = "display:block";                  }
    }
  }
  else
  {
    toast({
      type: 'error',
      title:i18n.t('error.label'),
      description: response.data.result.errorReposne,
      animation: 'bounce',
      time: 5000,

  });
  }
})
    }



    onInputChange=(event)=>
    {
      this.setState({user_name:event.target.value});
    }

    onCodeChange=(event)=>
    {
      this.setState({code:event.target.value});
    }
    onPasswordChange=(event)=>
    {
      this.setState({password:event.target.value});
    }

    onRePasswordChange=(event)=>
    {
      this.setState({re_password:event.target.value});
    }

   render () {
   return (
     <div>
     <form className="ui large form border radius content_form">
     <div className="stacked segment border_margin">

   <div className="reset_send_code">
     <div className="field">
       {this.state.isArabic ?
     <div className="ui fluid left icon input">
     <input placeholder={i18n.t('username.label')}  type="text" className="username" value={this.state.user_name} onChange={this.onInputChange}/>
     <i aria-hidden="true" className="user icon" style={{color:'#2ed9c3 '}}></i>
     </div>
     :
     <div className="ui fluid  icon input">
     <input placeholder={i18n.t('username.label')}  type="text" className="username" style={{textAlign:"right"}} value={this.state.user_name} onChange={this.onInputChange}/>
     <i aria-hidden="true" className="user icon" style={{color:'#2ed9c3 '}}></i>
     </div>
    }
     </div>

     <button type="button" className="ui large fluid button btn_login radius" onClick={this.resetSendCode.bind(this)}>{i18n.t('Send_Code.label')} </button>
  </div>


     <br/>


<div className="reset_check_code">
<div className="modalIsOpenError" >
             <p
               className="details_type"
               style={{
                 color:'red',
                 textAlign: this.state.isArabic ? "" : "right",
                 marginRight: this.state.isArabic ? "2%" : ""
               }}
             >
               {i18n.t("password_title.label")}
             </p>

             <br/>
             <p
               className="details_type"
               style={{
                 color:'red',
                 textAlign: this.state.isArabic ? "" : "right",
                 marginRight: this.state.isArabic ? "2%" : ""
               }}
             >
               {i18n.t("password_point1.label")}
             </p>
             <br/>
             <p
               className="details_type"
               style={{
                 color:'red',
                 textAlign: this.state.isArabic ? "" : "right",
                 marginRight: this.state.isArabic ? "2%" : ""
               }}
             >
               {i18n.t("password_point2.label")}
             </p>
             <br/>
             <p
               className="details_type"
               style={{
                 color:'red',
                 textAlign: this.state.isArabic ? "" : "right",
                 marginRight: this.state.isArabic ? "2%" : ""
               }}
             >
               {i18n.t("password_point3.label")}
             </p>
             <br/>
             <p
               className="details_type"
               style={{
                 color:'red',
                 textAlign: this.state.isArabic ? "" : "right",
                 marginRight: this.state.isArabic ? "2%" : ""
               }}
             >
               {i18n.t("password_point4.label")}
             </p>
             <br/>
             <p
               className="details_type"
               style={{
                 color:'red',
                 textAlign: this.state.isArabic ? "" : "right",
                 marginRight: this.state.isArabic ? "2%" : ""
               }}
             >
               {i18n.t("password_point5.label")}
             </p>
             <br/>
             <p
               className="details_type"
               style={{
                 color:'red',
                 textAlign: this.state.isArabic ? "" : "right",
                 marginRight: this.state.isArabic ? "2%" : ""
               }}
             >
               {i18n.t("password_point6.label")}
             </p>

   </div>
     <div className="field">
     {this.state.isArabic ?
     <div className="ui fluid left icon input">
     <input placeholder={i18n.t('code.label')} type="text" className="username" value={this.state.code} onChange={this.onCodeChange}/>
     <i aria-hidden="true" className="lock icon" style={{color:'#2ed9c3 '}}></i>
     </div>
     :
     <div className="ui fluid  icon input">
     <input placeholder={i18n.t('code.label')} type="text" className="username" style={{textAlign:"right"}} value={this.state.code} onChange={this.onCodeChange}/>
     <i aria-hidden="true" className="lock icon" style={{color:'#2ed9c3 '}}></i>
     </div>
     }
     </div>
     <div className="field">


     {this.state.isArabic ?
    <div className="ui fluid left icon input">
    <input placeholder={i18n.t('Password.label')} type="Password" className="username" value={this.state.password} onChange={this.onPasswordChange}/>
    <i aria-hidden="true" className="user icon" style={{color:'#2ed9c3 '}}></i>
    </div>
    :
    <div className="ui fluid  icon input">
    <input placeholder={i18n.t('Password.label')} style={{textAlign:"right"}} className="username" type="Password" value={this.state.password} onChange={this.onPasswordChange}/>
    <i aria-hidden="true" className="user icon" style={{color:'#2ed9c3 '}}></i>
    </div>
     }

    </div>

      <div className="field">

      {this.state.isArabic ?
      <div className="ui fluid left icon input">
      <input placeholder={i18n.t('re_pass.label')} type="Password" className="username" value={this.state.re_password} onChange={this.onRePasswordChange}/>
      <i aria-hidden="true" className="lock icon" style={{color:'#2ed9c3 '}}></i>
      </div>
      :
      <div className="ui fluid  icon input">
      <input placeholder={i18n.t('re_pass.label')} type="Password"  className="username" style={{textAlign:"right"}} value={this.state.re_password} onChange={this.onRePasswordChange}/>
      <i aria-hidden="true" className="lock icon" style={{color:'#2ed9c3 '}}></i>
      </div>
      }

      </div>

    <button className="ui large fluid button btn_login radius" onClick={this.resetCheckCode.bind(this)}>{i18n.t('Reset_Password.label')}</button>
</div>







<SemanticToastContainer/>

     </div>
     </form>
     </div>
          );
      }
   }


const mapStateToProps = (state)=>{
  return {...state}
}

export default connect(mapStateToProps)(FormForgetDesign);



/*


import React, { Component } from "react";
import { Button, FormGroup, FormControl, ControlLabel } from "react-bootstrap";
import "./Login.css";

export default class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: ""
    };
  }

  validateForm() {
    return this.state.email.length > 0 && this.state.password.length > 0;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleSubmit = event => {
    event.preventDefault();
  }

  render() {
    return (
      <div className="Login">
        <form onSubmit={this.handleSubmit}>
          <FormGroup controlId="email" bsSize="large">
            <ControlLabel>Email</ControlLabel>
            <FormControl
              autoFocus
              type="email"
              defaultValue={this.state.email}
              onChange={this.handleChange}
            />
          </FormGroup>
          <FormGroup controlId="password" bsSize="large">
            <ControlLabel>Password</ControlLabel>
            <FormControl
              defaultValue={this.state.password}
              onChange={this.handleChange}
              type="password"
            />
          </FormGroup>
          <Button
            block
            bsSize="large"
            disabled={!this.validateForm()}
            type="submit"
          >
            Login
          </Button>
        </form>
      </div>
    );
  }
}
*/
